import { marker } from '@colsen1991/ngx-translate-extract-marker';

export enum WidgetCategory {
    ORDER = 'ORDER',
    RFQ = 'RFQ',
    MISC = 'MISC',
    CHART = 'CHART',
    TASK_LIST = 'TASK_LIST',
    NEWS = 'NEWS',
    COST_CENTER = 'COST_CENTER',
}

export type WidgetCategoryNamesType = { [key in WidgetCategory]: string };

export const WidgetCategoryNames: WidgetCategoryNamesType = {
    [WidgetCategory.ORDER]: marker('Bestellung'),
    [WidgetCategory.RFQ]: marker('Anfrage'),
    [WidgetCategory.MISC]: marker('Sonstiges'),
    [WidgetCategory.CHART]: marker('Chart'),
    [WidgetCategory.TASK_LIST]: marker('meine Aufgaben'),
    [WidgetCategory.NEWS]: marker('News'),
    [WidgetCategory.COST_CENTER]: marker('Kostenstelle'),
};

export enum VisibilityType {
    MOBILE_ONLY = 'Mobile only',
    HIDDEN_BY_OPTIONS_SETTINGS_ENVIRONMENT = 'Hidden by options/settings/environment',
    ALWAYS_VISIBLE = 'Always visible',
}
